import { render, staticRenderFns } from "./ProductReport.vue?vue&type=template&id=6421bdd6&"
import script from "./ProductReport.vue?vue&type=script&lang=js&"
export * from "./ProductReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports